import React from 'react'

import { useFormContext, useController } from 'react-hook-form'
import { SelectInput } from 'modules/ui/atoms/SelectInput'

export type SelectFieldOption = {
  label: string
  value: string
}

export type SelectFieldProps = {
  id: string | number
  label: string
  options: Array<string | SelectFieldOption>
  error?: { message: string }
  placeholder?: string
  required?: boolean
  autoComplete?: string
  dataId?: string
  autoFocus?: boolean
  value?: string
  onFocus?: () => void
}

const SelectField = ({
  id,
  label,
  options,
  error,
  required,
  placeholder,
  autoComplete,
  dataId = '',
  autoFocus,
  value,
  onFocus,
}: SelectFieldProps) => {
  const { control } = useFormContext()

  const { field, fieldState, formState } = useController({
    name: `${id}`,
    control,
  })

  const { isDirty } = fieldState
  const { isSubmitted } = formState

  const structuredOptions = React.useMemo(
    () =>
      options.map((option) =>
        typeof option == 'string' ? { label: option, value: option } : option,
      ),
    [options],
  )

  return (
    <SelectInput
      {...field}
      options={structuredOptions}
      id={`${id}`}
      label={label}
      error={(isDirty || isSubmitted) && error ? error.message : undefined}
      required={required}
      placeholder={placeholder}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
      dataId={dataId}
      value={field.value ?? value ?? ''}
      onFocus={onFocus}
    />
  )
}

SelectField.displayName = 'SelectField'

export default SelectField
